export default {
    currentUser: {
        email: '',
        uid: '',
    },
    isLoading: false,
    listProjects: {},
    messages: {},
    checkins: {},
    records: {}
}


// WEBPACK FOOTER //
// ./src/store/state.js